// extracted by mini-css-extract-plugin
module.exports = {"barra":"DateChanger_barra__2pVBC","nome":"DateChanger_nome__3HrGL","bimestre":"DateChanger_bimestre__1QnTY","data":"DateChanger_data__LOWp2"};